import config from '../config';
import apiClient from './apiClient';

const getGeneralContent = async() => {
  try {
    const response = await apiClient.get(
      `${config.API_BASE_URL}/content`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export {getGeneralContent};
